import React from 'react'

const Medium = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
<path d="M26 14.3347C26 17.3816 25.4893 19.8531 24.8592 19.8531C24.2292 19.8531 23.7188 17.3822 23.7188 14.3347C23.7188 11.2872 24.2294 8.81641 24.8592 8.81641C25.4891 8.81641 26 11.287 26 14.3347Z" fill="currentColor"></path>
<path d="M23.0893 14.3347C23.0893 17.7362 21.6372 20.4947 19.8459 20.4947C18.0547 20.4947 16.6025 17.7362 16.6025 14.3347C16.6025 10.9333 18.0544 8.1748 19.8457 8.1748C21.637 8.1748 23.0891 10.9324 23.0891 14.3347" fill="currentColor"></path>
<path d="M15.9734 14.3352C15.9734 17.9488 13.0692 20.8782 9.4868 20.8782C5.90445 20.8782 3 17.9481 3 14.3352C3 10.7223 5.90423 7.79199 9.4868 7.79199C13.0694 7.79199 15.9734 10.7216 15.9734 14.3352Z" fill="currentColor"></path>
</svg>
    )
}

export default Medium
